import { UpdateMunicipalPropertyInput } from "@/graphql/generated/graphql";

import { MunicipalPropertyStand } from "./municipal-property-stand.model";
import { MunicipalPropertyStandSubmission } from "./municipal-property-stand-submission.model";
import { toMunicipalPropertyMasterDataInput } from "./to-municipal-property-master-data-input";
interface ToUpdateMunicipalPropertyInputOptions extends MunicipalPropertyStandSubmission {
  propertyId: string;
  stand: MunicipalPropertyStand;
}
export function toUpdateMunicipalPropertyInput({
  propertyId,
  stand,
  values,
  isOverwrite,
}: ToUpdateMunicipalPropertyInputOptions): UpdateMunicipalPropertyInput {
  return {
    ...toMunicipalPropertyMasterDataInput(values),
    id: propertyId,
    effectiveYear: values.effectiveYear,
    municipalityIdList: values.municipalityIdList,
    overwrite: isOverwrite,
    expectedUpdatedAt: stand.property.updatedAt,
    ...(isOverwrite ? { expectedStandUpdatedAt: stand.standUpdatedAt } : {}),
  };
}
